module.exports = __webpack_public_path__ + "static/seokjun.jin-131412b75ed5b7301049af030c710ec5.png";